var map = {
	"./img-1.jpg": 917,
	"./img-10.jpg": 977,
	"./img-11.jpg": 5563,
	"./img-12.jpg": 3293,
	"./img-2.jpg": 1212,
	"./img-3.jpg": 5306,
	"./img-4.jpg": 6531,
	"./img-5.jpg": 6486,
	"./img-6.jpg": 7328,
	"./img-7.jpg": 4628,
	"./img-8.jpg": 6495,
	"./img-9.jpg": 1604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8493;